const modal = function() {
  const modalHideClass = "modal-window--hidden";
  const $modalBtn = "[data-modal-target]";
  const $closeBtn = "[data-modal-close]";
  const $body = $("body");

  $body.on("click", $modalBtn, function() {
    const modalId = $(this).data("modal-target");

    $(modalId).removeClass(modalHideClass);
  });

  $body.on("click", $closeBtn, function() {
    const modalId = $(this).data("modal-close");

    $(modalId).addClass(modalHideClass);
  });
};

module.exports = modal();
